import { render, staticRenderFns } from "./MapHighlightDeptos.vue?vue&type=template&id=19f808c0&scoped=true"
import script from "./MapHighlightDeptos.vue?vue&type=script&lang=js"
export * from "./MapHighlightDeptos.vue?vue&type=script&lang=js"
import style0 from "./MapHighlightDeptos.vue?vue&type=style&index=0&id=19f808c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f808c0",
  null
  
)

export default component.exports